module.exports = __webpack_public_path__ + "1d59dae2270481cee00450047ffa46bc.svg";